import { render, staticRenderFns } from "./Expend.vue?vue&type=template&id=14b06486&scoped=true"
import script from "./Expend.vue?vue&type=script&lang=js"
export * from "./Expend.vue?vue&type=script&lang=js"
import style0 from "./Expend.vue?vue&type=style&index=0&id=14b06486&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b06486",
  null
  
)

export default component.exports